export const NAVIGATION_ROUTE = {
    home: '/',
    login:'/client/login',
    register:'/client/register',
    forgotPassword:'/forgot-password',
    resetPassword:'/reset-password/:token',
    api:'/client/api',
    subscription:'/client/plans',
    documentation:'/documentation',
    changePassword:'/client/change-password',
    billing:'/client/billing',
    adminApi: '/admin/api',
    adminProfile:'/admin/profile',
    adminUserManagement: '/admin/users',
    adminPlans: '/admin/plans',
    adminTransactions: '/admin/transactions',
    unauthorized:'/unauthorized',
};
